var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeineUploads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 63",
    style: {
      enableBackground: "new 0 0 77 63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5,14.9c-0.5,0-1,0-1.5,0.1C52.5,5.9,44,0,34.1,0C21.3,0,10.8,10.4,10.7,23.3C4.3,25.5,0,31.4,0,38.2 C0,46.9,7.1,54,15.8,54h13.5v9h18.6v-9h9.6C68.3,54,77,45.2,77,34.5S68.3,14.9,57.5,14.9z M47.8,43.4h6L38.6,22.5L23.1,43.4h6.1v6.7 H15.8c-6.5,0-11.9-5.3-11.9-11.9c0-5.6,3.8-10.3,9.2-11.5l1.6-0.4l-0.1-1.7c0-0.4,0-0.8,0-1.2c0-10.8,8.8-19.5,19.5-19.5 c8.6,0,16.1,5.5,18.7,13.7l0.5,1.6L55,19c0.8-0.1,1.7-0.2,2.5-0.2c8.6,0,15.6,7,15.6,15.6c0,8.6-7,15.6-15.6,15.6h-9.6V43.4z  M43.9,39.5V59H33.2V39.5h-2.3l7.6-10.3l7.6,10.3H43.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeineUploads);
export default __webpack_public_path__ + "static/media/MeineUploads.fb47476baed872e4ac99b3518156782d.svg";
export { ForwardRef as ReactComponent };